import React from "react";
import { clinicProfile } from "./clinicInfo";

interface ClinicPrintHeaderProps {
  title: string;
  subtitle?: string;
  meta?: React.ReactNode;
}

export default function ClinicPrintHeader({ title, subtitle, meta }: ClinicPrintHeaderProps) {
  return (
    <>
      <div className="print-header">
        <div className="clinic-brand">
          <div className="clinic-name">{clinicProfile.name}</div>
          <div className="clinic-tagline">{clinicProfile.tagline}</div>
        </div>
        <div className="clinic-contact">
          <div className="clinic-address">{clinicProfile.addressLines[0]}</div>
          <div className="clinic-address">{clinicProfile.addressLines[1]}</div>
          <div className="clinic-phone">Phone: {clinicProfile.phones.join(", ")}</div>
        </div>
      </div>
      <div className="document-title">
        <div>
          <h2>{title}</h2>
          {subtitle && <p>{subtitle}</p>}
        </div>
        {meta && <div className="document-meta">{meta}</div>}
      </div>
    </>
  );
}

